import React from "react";

export const TermsGate = React.memo(function TermsGate({ 
  isOpen, 
  termsChecked, 
  termsVersion,
  onCheckChange, 
  onAccept, 
  onCancel, 
  busy 
}) {
  if (!isOpen) return null;

  return (
    <div className="nr-termsGate">
      <div className="nr-termsGateHeader">
        <div>
          <div className="nr-termsGateTitle">Terms of Use</div>
          <div className="nr-muted" style={{ marginTop: 2 }}>Please review and accept to continue.</div>
        </div>
        <div className="nr-pill" style={{ fontSize: 12 }}>
          Version: <b style={{ marginLeft: 6 }}>{termsVersion}</b>
        </div>
      </div>

      <div className="nr-termsGateBody">
        <p style={{ marginTop: 0 }}>
          This dashboard signs transactions on the Proton/XPR blockchain and interacts with smart contracts.
          By using it you acknowledge and accept the following:
        </p>
        <ul style={{ marginTop: 0 }}>
          <li><b>Use at your own risk.</b> Transactions are irreversible and may result in loss of tokens or missed rewards.</li>
          <li><b>No guarantees.</b> Availability, eligibility calculations and outcomes are not guaranteed.</li>
          <li><b>Smart contract risk.</b> Bugs, exploits or third-party outages can cause unexpected behavior.</li>
          <li><b>You are responsible.</b> Always verify parameters in your wallet before signing.</li>
        </ul>
        <div style={{ marginTop: 8 }}>
          Read the full Terms:{" "}
          <a className="nr-link" href="/nftadminhub_terms.html" target="_blank" rel="noreferrer">
            /nftadminhub_terms.html
          </a>
        </div>
      </div>

      <div className="nr-termsGateCheck">
        <input
          type="checkbox"
          id="nrTermsChk"
          checked={termsChecked}
          onChange={(e) => onCheckChange(!!e.target.checked)}
        />
        <label htmlFor="nrTermsChk">
          I have read and agree to the <b>Terms of Use</b> (including the disclaimer and limitation of liability).
        </label>
      </div>

      <div className="nr-termsGateActions">
        <button className="nr-btn" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        <button className="nr-btn nr-btnPrimary" onClick={onAccept} disabled={busy || !termsChecked}>
          Accept &amp; Continue
        </button>
      </div>
    </div>
  );
});
